import { FC, useState } from "react"
import SidePanel from "../../side-panel"
import Tabs from "../../tabs"
import PerformanceChart from "../charts/performance-chart"
import { PricingProfile } from "../../../../types"

interface Props {
  pricingProfile?: PricingProfile
  onClose: () => void
}

const PricingProfileDetails: FC<Props> = ({ pricingProfile, onClose }) => {
  const [tab, setTab] = useState<string>("performance")

  return (
    <SidePanel
      title={pricingProfile?.title || ""}
      open={!!pricingProfile}
      onClose={onClose}
      actions={[]}
      titleClassName="text-xl font-semibold"
      hasTabs
    >
      <div className="h-full flex flex-col">
        <div>
          <Tabs
            currentTab={tab}
            tabs={[{ id: "performance", label: "Performance" }]}
            onChange={setTab}
          />
        </div>
        <div hidden={tab !== "performance"}>
          {pricingProfile && (
            <PerformanceChart
              profileId={pricingProfile.id}
              profileTitle={pricingProfile.title}
            />
          )}
        </div>
      </div>
    </SidePanel>
  )
}

export default PricingProfileDetails
